const WhyChooseUs = () => {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Reliability',
      description: 'Proven track record of consistent quality and on-time delivery with strict quality control measures and certified suppliers.',
    },
    {
      icon: 'ri-global-line',
      title: 'International Partnerships',
      description: 'Strong network of global suppliers and logistics partners ensuring seamless cross-border operations and market access.',
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Technical Expertise',
      description: 'Deep industry knowledge and technical proficiency in electronic components, spare parts, and equipment specifications.',
    },
    {
      icon: 'ri-rocket-line',
      title: 'Efficiency in Logistics',
      description: 'Optimized supply chain management with advanced tracking systems and streamlined customs clearance procedures.',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Dedicated Support',
      description: 'Professional customer service team providing personalized assistance and technical consultation throughout the process.',
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Competitive Pricing',
      description: 'Direct relationships with manufacturers and bulk purchasing power enable us to offer competitive wholesale prices.',
    },
  ];

  return (
    <section className="py-24 px-6 lg:px-12 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-flex items-center space-x-2 px-4 py-2 bg-blue-50 rounded-full mb-6">
              <i className="ri-star-line text-blue-600"></i>
              <span className="text-sm text-blue-600 font-semibold">Why Choose Us</span>
            </div>

            <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
              Your Trusted Partner in <strong>Technical Supply</strong>
            </h2>

            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              &nbsp;Lynora has established itself as a reliable partner for businesses seeking quality electronic components and efficient supply chain solutions.
            </p>

            <div className="space-y-6">
              {features.slice(0, 3).map((feature, index) => (
                <div key={index} className="flex items-start space-x-4 group">
                  <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-blue-600 to-cyan-500 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <i className={`${feature.icon} text-white text-2xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-slate-900 mb-2">{feature.title}</h3>
                    <p className="text-slate-600 leading-relaxed">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="absolute -top-8 -left-8 w-64 h-64 bg-blue-100 rounded-full blur-3xl opacity-50"></div>
            <div className="absolute -bottom-8 -right-8 w-64 h-64 bg-cyan-100 rounded-full blur-3xl opacity-50"></div>

            <div className="relative grid grid-cols-1 gap-6">
              {features.slice(3).map((feature, index) => (
                <div
                  key={index}
                  className="bg-gradient-to-br from-slate-50 to-white rounded-2xl p-8 border border-slate-200 hover:border-blue-300 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
                >
                  <div className="flex items-start space-x-4">
                    <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-blue-600 to-cyan-500 rounded-2xl flex items-center justify-center shadow-lg">
                      <i className={`${feature.icon} text-white text-2xl`}></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-slate-900 mb-2">{feature.title}</h3>
                      <p className="text-slate-600 leading-relaxed">{feature.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
